
import { computed, defineComponent } from 'vue'
// Icons
import LegalIcon from '@/assets/images/ic_legal_info.svg'
import DressCodeIcon from '@/assets/images/ic_dress_code.svg'
import RefundIcon from '@/assets/images/ic_refund_policy.svg'
// Helpers
import { getCleanHTML } from '@/utils/helpers'
// Components
import DashedGreyLine from '@/components/DashedGreyLine.vue'
import EventTextSection from '@/viewsTicketing/Events/components/EventTextSection.vue'

export default defineComponent({
	name: 'EventDetailsText',
	components: { EventTextSection, DashedGreyLine },

	props: {
		htmlDescription: {
			type: String,
			default: ''
		},
		legalInformation: {
			type: String,
			default: ''
		},
		dressCode: {
			type: String,
			default: ''
		},
		refundPolicy: {
			type: String,
			default: ''
		}
	},

	setup(props) {
		// Computed
		const legalIcon = computed(() => LegalIcon)
		const dressCodeIcon = computed(() => DressCodeIcon)
		const refundIcon = computed(() => RefundIcon)
		const cleanHTMLDesc = computed(() => getCleanHTML(props.htmlDescription))
		const dressCode = computed(() => props.dressCode)
		const legalInformation = computed(() => props.legalInformation)
		const refundPolicy = computed(() => props.refundPolicy)

		return {
			legalIcon,
			dressCodeIcon,
			refundIcon,
			cleanHTMLDesc,
			dressCode,
			legalInformation,
			refundPolicy
		}
	}
})
